module.exports = __webpack_public_path__ + "img/pin-black-icon.66ee78a6.svg";